import React from "react";
import { motion } from "framer-motion";
import section2Graphic from "@/assets/section2-graphic-v2.webp";
import section2GraphicMobile from "@/assets/section2-graphic-mobile.webp";
import gradientBackground from "@/assets/gradient-background-v2.webp";

export function AboutSection() {
  return (
    <section
      id="learn-more-section"
      className="w-full relative overflow-hidden"
      aria-labelledby="about-heading"
    >

      <div className="w-full max-w-[1440px] mx-auto relative z-10">
        <div className="flex items-center max-lg:flex-col py-24 max-lg:py-16">
          {/* Illustration with background */}
          <motion.div
            className="flex-1 flex justify-center px-8 max-lg:px-4 relative"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
          >
            {/* Gradient background - positioned relative to image container */}
            <img
              src={gradientBackground}
              alt=""
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-contain pointer-events-none"
              width={1920}
              height={1860}
              loading="lazy"
              decoding="async"
            />
            <img
              src={section2Graphic}
              srcSet={`${section2GraphicMobile} 760w, ${section2Graphic} 1200w`}
              sizes="(max-width: 1023px) 100vw, 600px"
              alt="Illustration of an older adult using GrandPad tablet surrounded by connection labels: Care Team, Family, Support Services, Care Coordinator, and GrandPad Team"
              className="w-full h-auto max-w-[600px] relative z-10"
              width={1920}
              height={1842}
              loading="lazy"
              decoding="async"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            className="flex-1 flex flex-col gap-4 px-8 max-lg:px-8 max-lg:py-8 max-lg:text-center max-sm:px-4"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.15 }}
          >
            <span className="text-caption text-beacon uppercase tracking-wider pl-[3px] max-lg:pl-0 block">
              About Us
            </span>
            <h2
              id="about-heading"
              className="text-h1 text-anchor"
            >
              What is GrandPad?
            </h2>
            <p className="text-body-lg text-anchor max-w-[520px] max-lg:max-w-none max-lg:mx-auto">
              GrandPad is a secure, customizable, easy-to-use tablet designed
              specifically for older adults to safely connect, communicate, and stay
              engaged with their families and care teams.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
